import SearchFormDatepicker from './components/SearchForm/SearchFormDatepicker/SearchFormDatepicker';
export const renders = {
    SearchFormDatePicker: SearchFormDatepicker
};
